import { render, staticRenderFns } from "./index.vue?vue&type=template&id=f8c51888&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=f8c51888&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c51888",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c51888')) {
      api.createRecord('f8c51888', component.options)
    } else {
      api.reload('f8c51888', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=f8c51888&scoped=true", function () {
      api.rerender('f8c51888', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SmartCard/index.vue"
export default component.exports